module.exports = __webpack_public_path__ + "static/media/3_Jessika_L@2x.d85e9e8d.jpg";